// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"k2-z","colorTextValue":"l2-z","swatches":"m2-z","collapseLink":"n2-z","isCollapsed":"o2-z","dropdown":"p2-z","disabled":"q2-z"};